/*global VXConfig*/
import Flux from '../../flux/Flux';
import { getCommonTranslation } from '../../utils/TranslationHelper';

function getDay(date) {
	const day = date.getDate();
	return day < 10 ? '0' + day : day;
}

function getMonth(date) {
	const month = date.getMonth() + 1;
	return month < 10 ? '0' + month : month;
}

function getYear(date) {
	return date.getFullYear();
}

function getHour(date) {
	const hour = date.getHours();
	return hour < 10 ? '0' + hour : hour;
}

function getMinutes(date) {
	const minutes = date.getMinutes();
	return minutes < 10 ? '0' + minutes : minutes;
}

function getSeconds(date) {
	const seconds = date.getSeconds();
	return seconds < 10 ? '0' + seconds : seconds;
}

function getDate(dateString) {
	const date = dateString ? new Date(dateString) : new Date();

	return {
		day: getDay(date),
		month: getMonth(date),
		year: getYear(date),
		hour: getHour(date),
		minutes: getMinutes(date),
		seconds: getSeconds(date),
	};
}

function getLanguageExtension() {
	const base = VXConfig.language.toLowerCase();
	switch (base) {
		case Flux.Constants.Languages.EN:
			return base + '-GB';
		case Flux.Constants.Languages.ES:
			return base + '-ES';
		default:
			return Flux.Constants.Languages.DE + '-DE';
	}
}

function getFormattedDate(dateString = Date.now(), monthFormat = '2-digit') {
	const options = {
		day: '2-digit',
		month: monthFormat,
		year: 'numeric',
	};
	return new Date(dateString).toLocaleDateString(getLanguageExtension(), options);
}

function getFormattedTime(dateString) {
	return new Date(dateString).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}

function timeDifference(date) {
	const now = new Date();
	const ago = new Date(date);
	const msMinute = 60 * 1000;
	const msHour = msMinute * 60;
	const msDay = msHour * 24;
	const difference = now - ago;

	/*
	 *	< 1min == just now
	 *	< 1h   == n min(s)
	 *	< 1d   == n hour(s)
	 *   <= 6d  == n day(s)
	 *   > 7d   == dd.mm.yyyy
	 */

	if (difference < msMinute) {
		return getCommonTranslation('just-now');
	} else if (difference < msHour) {
		const minutes = Math.round(difference / msMinute);
		return getCommonTranslation(minutes > 1 ? 'n-minutes-ago' : 'n-minute-ago', minutes);
	} else if (difference < msDay) {
		const hours = Math.round(difference / msHour);
		return getCommonTranslation(hours > 1 ? 'n-hours-ago' : 'n-hour-ago', hours);
	} else {
		const days = Math.round(difference / msDay);
		if (days > 6) {
			return getFormattedDate(date);
		}
		return getCommonTranslation(days > 1 ? 'n-days-ago' : 'n-day-ago', days);
	}
}

export { getDate, getFormattedDate, getFormattedTime, timeDifference };
